//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { IState } from 'angular-ui-router';
import { Dictionary } from 'lodash';

import { mapObject } from '@utils/mapObject';
import {
  INamedStateWithData, IStateWithData,
} from 'app/initialization/routing/stateHelpers';

/**
 * This file is for utilities needed specifically in top-level-states.ts.
 * To avoid import loops, please do not import anything in this file that relies on
 * top-level-states.ts.
 */

export function addNamesToStates<T extends Record<string, IState>>(states: T) {
  return mapObject(states, (value, key) => ({
    ...value,
    name: key,
  })) as { [idx in keyof T]: (T[idx] & { name: string }) };
}

export function addDashboardParentToStates<T extends Dictionary<IStateWithData>>(states: T): T {
  return mapObject(states, (state: IStateWithData) => {
    const isDashboardTopLevelState: boolean = !state.parent && !state.name?.includes('.');
    if (isDashboardTopLevelState) {
      return { ...state, parent: 'dashboard' };
    }
    return state;
  }) as T;
}
